
/**************************************************************************************
 * *** Default Data Object for generating Columns of Result File List Table***
 * @Important: This Object will Have to be updated accordingly with @param: const column 
 * variable that is defined in ResultList.js
 *************************************************************************************/
export const columnDataObj = {
  key: 0,
  file: "file",
  action: {
      id: "sess_id",
      url: "url",
      link: "file",
  },
  view: {
      id: "sess_id",
      url: "url",
      link: "file",
      types: [],
  },
  description: "description",
}

/**************************************************************************************
 * The front end will display ALL files return by backend API
 * 
* For Files that will be marked for special features can be listed here
* for example: adding a breif description of the file or a visualization button
* @Important: for proper rendering, the ORDER of file names in output_files and file_desc
* will Have To Match! 
*************************************************************************************/

export const output_files = [
  "peptides.txt",
  "proteinGroups.txt",
  "msms.txt",
  "summary.txt",
  "MetaLab.taxonomy.xlsx",
  "Unipept.taxonomy.xlsx",
  "Biom_MetaLab.biom",
  "Unipept.iMetaLab.tree.csv",
  "MetaLab.iMetaLab.tree.csv",
  "function.csv", 
  "function.xlsx", 
  "function.xml", 
  "MetaLab_peptide.xlsx", //verson 1.2.0
  "MetaLab_taxonomy.xlsx", //verson 1.2.0
  "Unipept_peptide.xlsx", //verson 1.2.0
  "Unipept_taxonomy.xlsx" //verson 1.2.0
];

export const file_descs = [
  {
      name: "peptides.txt", 
      desc: "identified peptide list", 
      view: []
  },
  {
      name: "proteinGroups.txt", 
      desc: "identified protein list", 
      view: []
  },
  {
      name: "msms.txt", 
      desc: "peptide spectra matches list", 
      view: []
  },
  {
      name: "summary.txt", 
      desc: "summary of peptide identification result", 
      view: []
  },
  {
      name: "MetaLab.taxonomy.xlsx", 
      desc: "peptides and taxa lists generated by iMetaLab built-in database", 
      view: []
  },
  {
      name: "Unipept.taxonomy.xlsx", 
      desc: "peptides and taxa lists generated by Unipept web service", 
      view: []
  },
  {
      name: "Biom_MetaLab.biom", 
      desc: "peptides and taxa lists generated by iMetaLab in .biom format, which can be used by other visualization tools", 
      view: []
  },
  {
      name: "Unipept.iMetaLab.tree.csv", 
      desc: "peptides and taxa lists generated by Unipept web service processed for iMetaLab Data Visualization of Pie chart and Tree chart", 
      view: ['MetaMap']
  },
  {
      name: "MetaLab.iMetaLab.tree.csv", 
      desc: "peptides and taxa lists generated by iMetaLab built-in database processed for iMetaLab Data Visualization of Pie chart and Tree chart", 
      view: ['MetaMap']
  },
  {
      name: "function.csv", 
      desc: "functional annotation of identified proteins in CSV format", 
      view: []
  },
  {
      name: "function.xlsx", 
      desc: "functional annotation of identified proteins in xlsx format", 
      view: []
  },
  {
      name: "function.xml", 
      desc: "functional annotation of identified proteins in xml format", 
      view: []
  },
  {
      name: "MetaLab_peptide.xlsx", 
      desc: "taxonomy in peptide in xlsx format", 
      view: []
  },
  {
      name: "MetaLab_taxonomy.xlsx", 
      desc: "peptides and taxa lists generated by iMetaLab built-in database", 
      view: []
  },
  {
      name: "Unipept_peptide.xlsx", 
      desc: "taxonomy in peptide in xlsx format", 
      view: []
  },
  {
      name: "Unipept_taxonomy.xlsx", 
      desc: "peptides and taxa lists in xlsx format", 
      view: []
  },
];